
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Текущий', path: '/tms/standards' },
            { id: 2, name: 'Архив', path: '/tms/standards/archive' },
        ]

        return { tabs }
    },
})
